import CircleAWords from "../../components/LKG/English/PhoneticWords/CircleWords";
import FillBlanks from "../../components/LKG/English/PhoneticWords/FillBlanks";
import MatchWords from "../../components/LKG/English/PhoneticWords/MatchWords";
import TrueFalse from "../../components/LKG/English/PhoneticWords/TrueFalse";
import WordSearch from "../../components/LKG/English/PhoneticWords/WordSearch";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/lkg/english-language/phonetic-words/word-search", title: "Word Search", component: WordSearch },
    { url: "/lkg/english-language/phonetic-words/circle-words", title: "Choose Words", component: CircleAWords },
    { url: "/lkg/english-language/phonetic-words/match-words", title: "Match Words", component: MatchWords },
];

export default topics;